import { formatDate } from '@/web-task/filter.js'
import { feeFields, conFeeFields, feeMap, capUpperCase } from './config'

// 伤者电话（取第一个）
function getFirstPhone(str) {
	if (str) {
		return str.split(',')[0]
	} else {
		return ''
	}
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let ownerInfo = injured.owner || {}
	let injuredArr = injured.injuredList,
		injuredAgreements = []
	if (!(injuredArr && injuredArr.length > 0)) {
		injuredArr = [{ injuredName: '' }]
	}

	injuredArr.forEach(injuredItem => {
		let tempDate = new Date(order.accidentDate)

		let costArr = [],
			costMap = {},
			feeMap = {
				medicalFee: '医疗费',
				furtherMedicalFee: '续医费',
				mealsFee: '住院伙食补助费',
				compensation: '误工费赔偿金额',
				caregiversFee: '护理费赔偿金额',
				commuteFee: '交通费赔偿金额',
				otherFee: '其他（物损、车损等）',
			}

		// 协议是否展示最终调解金额
		let isConciliationFeeConfirm = false
		for (let key of conFeeFields) {
			if (injuredItem.agreement && key in injuredItem.agreement) {
				isConciliationFeeConfirm = true
				break
			}
		}

		for (let key of feeFields) {
			if (injuredItem.agreement && key in injuredItem.agreement) {
				if (isConciliationFeeConfirm) {
					// 调解已完成并且当前伤者为调解成功 为0费用项不写进协议
					if (Number(injuredItem.agreement[`conciliate${capUpperCase(key)}`])) {
						costArr.push(feeMap[key])
						costMap[feeMap[key]] =
							injuredItem.agreement[`conciliate${capUpperCase(key)}`]
					}
				} else {
					if (Number(injuredItem.agreement[key])) {
						costArr.push(feeMap[key])
						costMap[feeMap[key]] = injuredItem.agreement[key]
					}
				}
			}
		}
		let singleAgreement = {
			partyA: {
				name: ownerInfo.ownerName,
				gender: setting.sexMap[ownerInfo.sex],
				identity: setting.idTypeMap[ownerInfo.idType],
				identityNumber: ownerInfo.idNo,
				phoneNumber: getFirstPhone(ownerInfo.ownerPhone),
			},
			partyB: {
				name: injuredItem.injuredName,
				gender: setting.sexMap[injuredItem.sex],
				identity: setting.idTypeMap[injuredItem.idType],
				identityNumber: injuredItem.idNo,
				phoneNumber: getFirstPhone(injuredItem.injuredPhone),
			},
			address: `${order.clinicArea}${order.address}`,
			// 事故发生时间
			date: {
				year: tempDate.getFullYear(),
				month: tempDate.getMonth() + 1,
				date: tempDate.getDate(),
			},
			// 所涉及赔偿项
			costArr: costArr,
			costMap: costMap,
			signDate: formatDate(
				(injuredItem.agreement && injuredItem.agreement.injuredSignTime) ||
					new Date()
			),
			status: injuredItem.agreement && injuredItem.agreement.conciliationStatus,
			total:
				injuredItem.agreement &&
				(isConciliationFeeConfirm
					? injuredItem.agreement.conciliateSumFee
					: injuredItem.agreement.sumFee),
			ownerSignUrl: injuredItem.agreement && injuredItem.agreement.ownerSignUrl,
			injuredSignUrl:
				injuredItem.agreement && injuredItem.agreement.injuredSignUrl,
		}

		injuredAgreements.push(singleAgreement)
	})

	return injuredAgreements
}
